module.exports = __webpack_public_path__ + "static/media/IntroDemo08-blank.edee6df1.png";